import React from "react";
import Avvvatars from "avvvatars-react";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
interface StudentSideBarProps {
  userData?: any;
}

const StudentSidebar: React.FC<StudentSideBarProps> = ({ userData }) => {
  const { selectedYear } = useAcademicYear();

  return (
    <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
      <div className="stickybar pb-4">
        <div className="card border-white">
          <div className="card-header">
            <div className="d-flex align-items-center flex-wrap row-gap-3">
              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                {userData?.avatar ? (
                  <img
                    src={userData?.avatar}
                    alt={`${userData?.lastname} ${userData?.firstname}`}
                  />
                ) : (
                  <Avvvatars
                    value={`${userData.firstname?.charAt(0) || ""}${userData.lastname?.charAt(0) || ""}`}
                    style="character" // ou "character"
                    size={70}
                  />
                )}
              </div>
              <div className="overflow-hidden">
                {userData?.statut ? (
                  <span className="badge badge-soft-success d-inline-flex align-items-center mb-1">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Active
                  </span>
                ) : (
                  <span className="badge badge-soft-danger d-inline-flex align-items-center mb-1">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Inactive
                  </span>
                )}
                <h5 className="mb-1 text-truncate">{`${userData?.firstname} ${userData?.lastname}`}</h5>
                <p className="text-primary">{userData?.matricule}</p>
              </div>
            </div>
          </div>
          {/* Basic Information */}
          <div className="card-body">
            <h5 className="mb-3">Information de Base</h5>
            <dl className="row mb-0">
              <dt className="col-6 fw-medium text-dark mb-3">Année</dt>
              <dd className="col-6 mb-3">{selectedYear?.label || "Aucun"}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Classe</dt>
              <dd className="col-6 mb-3">
                {userData?.class
                  ? `${userData?.class?.Level?.label} - ${userData?.class?.label}`
                  : "Aucun"}
              </dd>
              <dt className="col-6 fw-medium text-dark mb-3">Genre</dt>
              <dd className="col-6 mb-3">{userData?.sexe}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Naissance</dt>
              <dd className="col-6 mb-3">
                { userData?.birthday && new Date(userData?.birthday).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}{" "}
                {userData?.place_birth && `à ${userData?.place_birth}`}
              </dd>
            </dl>
          </div>
          {/* /Basic Information */}
        </div>
        {/* Primary Contact Info */}
        <div className="card border-white">
          <div className="card-body">
            <h5 className="mb-3">Contact</h5>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-phone" />
              </span>
              <div>
                <span className="text-dark fw-medium mb-1">
                  Numéro téléphone
                </span>
                <p>{userData?.number}</p>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-mail" />
              </span>
              <div>
                <span className="text-dark fw-medium mb-1">Adresse Mail</span>
                <p>{userData?.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentSidebar;
